var map = {
	"./events-cat.webp": 2088,
	"./games-cat.webp": 2089,
	"./live-casino-cat.webp": 2090,
	"./lottery-cat.webp": 2091,
	"./other-cat.webp": 2092,
	"./p2p-cat.webp": 2093,
	"./pd-table.webp": 2094,
	"./privacy-policy-title-bm.webp": 2095,
	"./privacy-policy-title-cn.webp": 2096,
	"./privacy-policy-title-id.webp": 2097,
	"./privacy-policy-title.webp": 2098,
	"./promos-1.webp": 2099,
	"./promos-2.webp": 2100,
	"./promos-3.webp": 2101,
	"./promos-4.webp": 2102,
	"./question.webp": 2103,
	"./sideBar-bg.webp": 2104,
	"./slot-cat.webp": 2105,
	"./special-cat.webp": 2106,
	"./sports-cat.webp": 2107
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 480;